import { render, staticRenderFns } from "./slettementList.vue?vue&type=template&id=2d050cd3&"
import script from "./slettementList.vue?vue&type=script&lang=js&"
export * from "./slettementList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports